import {Signals} from "@/Imports";
import Facade from "@/Facade";
import LocalizedPIXIText from "@localisation/LocalizedPIXIText";
import FormatData from "@/application/FormatData";
import BaseContainer from "@base/container/BaseContainer";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";

export default class MultiplierContainer extends BaseContainer {

  constructor(data) {
    super()

    this.init()
  }

  init(data) {
    Signals.multiplier.add(this.updateMultiplier, this)
    Signals.roundStart.add(this.onRoundStart, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.makeBets.add(this.onMakeBets, this)

    Signals.stopFeature.add(this.onStopFeature, this)

    this.container = new PIXI.Container()
    this.addChild(this.container)
    this.container.position.set(0, 0)
    // this.container.filters = [new PIXI.filters.DropShadowFilter()]

    this.X = new LocalizedPIXIText(' X ', Facade.textFactory.getStyle('multiplierX'))
    this.X.resolution = 10
    this.container.addChild(this.X)
    this.X.y -= 16
    this.multiplierValue = new LocalizedPIXIText('1.00', Facade.textFactory.getStyle('multiplier'))
    this.multiplierValue.resolution = 2
    this.container.addChild(this.multiplierValue)
    this.multiplierValue.x = 0

    this.anim = new SpineAnimation('multiplierHighLightAnim')
    this.addChild(this.anim)
    this.anim.position.set(-275, -115)
    this.anim.visible = false
    this.visible = false
  }

  updateMultiplier(multiplier) {
    this.multiplierValue.text = FormatData.formatToFixed(Number(multiplier))

    this.multiplierValue.pivot.set(this.multiplierValue.width / 2, this.multiplierValue.height / 2)
    this.X.x = -(this.multiplierValue.width / 2 + 38)
    this.X.text = ''
    this.X.text = 'x'
  }

  onRoundStart() {
    this.X.text = ''
    this.X.text = 'x'
    this.multiplierValue.text = '1.00'

    this.container.pivot.set(this.container.width / 2, this.container.height / 2)

    // TweenMax.to(this.container.scale, 0.3, {
    //   x: 1.2, y: 1.2, yoyo: true, repeat: -1, ease: Linear.ease, update: () => {
    //     //this.container.pivot.set(this.container.width / 2, this.container.height / 2)
    //   }
    // })

    this.visible = true
  }

  onRoundEnd() {
    this.updateMultiplier(Facade.model.finalMultiplier)
    this.container.scale.set(1)

    this.anim.visible = false

    // TweenMax.killTweensOf(this.container.scale)
    // TweenMax.killTweensOf(this.container)
  }

  onMakeBets() {
    this.X.text = ''
    this.X.text = 'x'

    this.visible = false
    this.multiplierValue.text = `1.00`
  }

  onStopFeature() {
    this.anim.visible = true
    this.anim.start(['MulHighLightAnim'], [false])
  }

}

